import { render, staticRenderFns } from "./UploadImageUrl.vue?vue&type=template&id=234a6bea&scoped=true"
import script from "./UploadImageUrl.vue?vue&type=script&lang=js"
export * from "./UploadImageUrl.vue?vue&type=script&lang=js"
import style0 from "./UploadImageUrl.vue?vue&type=style&index=0&id=234a6bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234a6bea",
  null
  
)

export default component.exports